// import React, { useEffect, useState } from 'react';
// import Hero from "../components/Hero";

interface Props {
  children: React.ReactNode;
}

const LayoutSocialBooking = ({ children }: Props) => {
    // const [showSearchBar, setShowSearchBar] = useState(false);

  // useEffect(() => {
  //   const timer = setTimeout(() => {
  //     setShowSearchBar(true);
  //   }, 1000); // 5000ms = 5 seconds

  //   return () => clearTimeout(timer);
  // }, []);

  return (
     <div className="flex flex-col ">
      <div className="container mx-auto py-10 flex-1">{children}</div>
    </div>
  );
};
export default LayoutSocialBooking;
